import { yup } from '@guiker/yup-util'

export const activateUser = yup
  .object({
    token: yup.string().required(),
  })
  .required()
